import script from "./ai-property-listing-wizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ai-property-listing-wizard.vue?vue&type=script&setup=true&lang=ts"

import "./ai-property-listing-wizard.vue?vue&type=style&index=0&id=0b00598d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b00598d"]])

export default __exports__